<ng-template #sheetTemplate>
  <div
    class="phx-sheet-panel"
    [class.phx-sheet-dragging]="_dragHeight !== null"
    [style.height.px]="panelHeight"
    (keydown)="onKeydown($event)"
    (pointerdown)="onPanelPointerDown($event)"
    tabindex="-1"
  >
    <div class="phx-sheet-drag-handle" phx-sheet-drag-handle>
      <div class="phx-sheet-drag-handle-bar" (click)="setExpanded(!phxExpanded)"></div>
    </div>
    <ng-content></ng-content>
  </div>
</ng-template>
